import React from 'react';
import { getAppointmentPaymentCardMeta } from '../../utils/appointmentUtils';
import {
  formatStatusPillLabel,
  getAppointmentStatusPillClass,
  getAppointmentStatusPillLabel,
  getAppointmentStatusPillMeta,
} from './appointmentStatusPillUtils';
import './styles/AppointmentStatusPill.css';

/**
 * Solid status pill shared by Today, Pending Confirmation, and Upcoming lists.
 */
export function AppointmentStatusPill({
  appointment,
  status,
  label,
  labelOverride,
  className = '',
}) {
  let pillClass = 'confirmed';
  let pillLabel = 'confirmed';

  if (appointment) {
    const meta = getAppointmentStatusPillMeta(appointment, appointment.rescheduleStatus);
    pillClass = meta.className;
    pillLabel = labelOverride || meta.label;
  } else if (status) {
    pillClass = getAppointmentStatusPillClass(status);
    pillLabel = labelOverride || label || getAppointmentStatusPillLabel(status);
  } else if (labelOverride) {
    pillClass = 'pending';
    pillLabel = labelOverride;
  }

  return (
    <span className={`appointment-status ${pillClass} ${className}`.trim()}>
      {formatStatusPillLabel(pillLabel)}
    </span>
  );
}

export function AppointmentPaymentPill({ appointment, className = '' }) {
  const paymentMeta = getAppointmentPaymentCardMeta(appointment);
  if (!paymentMeta) return null;

  return (
    <span className={`appointment-status ${paymentMeta.cssClass} ${className}`.trim()}>
      {formatStatusPillLabel(paymentMeta.label)}
    </span>
  );
}

export default AppointmentStatusPill;
